export default {
  notification: null,
  pendingRequestsCount: 0,
  configurations: {},
};
